// ITEM-2 (FC-011): pure helper for the instruction-audio AUTOPLAY decision.
//
// Kept PURE and component-free so it is unit-testable without importing FlashCards
// (which transitively pulls in the react-dnd barrel Jest cannot transform) — same
// pattern as frameDesign.js. The component calls shouldAutoplayInstruction() when a
// card becomes active and plays via the shared `playInstructionsAudio` event only
// when this returns true.

// Does the given card have instruction audio?
export function hasInstructionAudio(card) {
  return !!(card && card.instruction && card.instruction.audio);
}

// Decide whether to AUTOPLAY the active card's instruction audio right now.
// Rules (FC-011 item 2):
//   - the card must have instruction audio;
//   - it must not already have been auto-played this session (one per active card),
//     which is what prevents a flip / re-render / typing from retriggering it —
//     those keep the same active card id, so lastAutoplayedId === card.id.
// Returns true only when autoplay should fire for this card.
export function shouldAutoplayInstruction(card, lastAutoplayedId) {
  if (!hasInstructionAudio(card)) return false;
  if (lastAutoplayedId === card.id) return false;
  return true;
}
